import React from 'react';
import Reflux from 'reflux';
import Modal from 'shared/components/misc/modal.jsx';
import UIRegions from 'shared/constants/UIRegions';
import { Grid, Row, Col, Input, Button } from 'bootstrap';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import CuesheetCellLinkActions from 'flux/actions/cuesheet/CuesheetCellLinkActions';
import CuesheetCellLinkStore from 'flux/stores/cuesheet/CuesheetCellLinkStore';
import ModalActions from 'flux/actions/ModalActions';
import Tile from 'main/components/misc/tile';
import DocIcon from 'shared/components/event/docIcon.jsx';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import Infinite from 'react-infinite';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import UpgradeConstants from 'shared/constants/UpgradeConstants.js';
import PermissionStore from 'flux/stores/PermissionStore';
import UpgradeAlertModalActions from 'flux/actions/UpgradeAlertModalActions';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

const InsertLinkButton = ({ onClick }) => {
  return (
    <Col md={24} className="text-center">
      <Button onClick={onClick}>Insert Link</Button>
    </Col>
  );
};

const DocListItem = ({ item, selectedItemId }) => {
  let selected = item.get('_id') === selectedItemId;

  return (
    <div
      className="doc-infinite-list-item"
      onClick={() => {
        CuesheetCellLinkActions.selectDocForInsert(item.get('_id'));
      }}
    >
      <DocIcon doc={item} />
      <div className="doc-list-item-name">{item.get('name')}</div>

      <div className="doc-list-item-select">
        <Icon name={selected ? 'check-circle-o' : 'circle-o'} />
        &nbsp; Select
      </div>
    </div>
  );
};

const InfiniteDocList = React.createClass({
  mixins: [Reflux.connect(CuesheetCellLinkStore, 'form')],

  _getLoadingNode() {
    let state = this.state.form;
    let docCount = state.get('docCount');

    if (state.get('docs').size >= docCount) {
      return null;
    }

    return <div className="doc-infinite-list-item">Loading...</div>;
  },

  render() {
    let state = this.state.form;
    let loading = state.get('loadingDocs');

    let docItemNodes = state.get('docs').map((item) => {
      return (
        <DocListItem item={item} selectedItemId={state.get('selectedDocId')} />
      );
    });

    return (
      <Infinite
        elementHeight={30}
        infiniteLoadBeginEdgeOffset={1}
        containerHeight={250}
        onInfiniteLoad={() => {
          setTimeout(function () {
            CuesheetCellLinkActions.loadMoreDocs();
          }, 1000);
        }}
        loadingSpinnerDelegate={this._getLoadingNode()}
        isInfiniteLoading={loading}
        className="doc-infinite-list"
      >
        {docItemNodes}
      </Infinite>
    );
  },
});

const ExternalLinkForm = React.createClass({
  render() {
    return (
      <Row>
        <Col md={24}>
          <Input
            ref="text"
            type="text"
            label="Text to display:"
            defaultValue="Link"
          />
        </Col>
        <Col md={24}>
          <Input ref="link" type="text" label="Link to URL:" />
        </Col>
        <InsertLinkButton onClick={this._handleInsertClick} />
      </Row>
    );
  },

  _handleInsertClick() {
    var text = this.refs.text.getValue();
    var link = this.refs.link.getValue();
    /**
     * If link does not contain 'http' in it, prepend link with it.
     */
    if (text === '') {
      text = 'Link';
    }

    if (link.indexOf('http') == -1) link = `http://${link}`;

    CuesheetCellActions.saveSelectedCellTextWithLink(text, link);
    ModalActions.hide(UIRegions.CellLink);
  },
});

const DocLinkFormInput = React.createClass({
  render() {
    return (
      <Input
        ref="term"
        type="text"
        placeholder="Search for files"
        defaultValue=""
        onChange={(e) =>
          CuesheetCellLinkActions.updateDocSearchTerm(e.target.value)
        }
      />
    );
  },
});

const DocLinkForm = React.createClass({
  mixins: [Reflux.connect(CuesheetCellLinkStore, 'form')],

  render() {
    let submitButtonNode = null;

    if (this.state.form.get('selectedDocId')) {
      submitButtonNode = <InsertLinkButton onClick={this._handleInsertClick} />;
    }

    return (
      <Row>
        <div className="docs-title">
          <Col md={24}>
            Insert a link to a file that has been uploaded to{' '}
            <strong>Shoflo Docs</strong>.
          </Col>
        </div>

        <Col md={24}>
          <DocLinkFormInput />
        </Col>
        <Col md={24}>
          <div className="form-group">
            <InfiniteDocList />
          </div>
        </Col>
        {submitButtonNode}
      </Row>
    );
  },

  _handleInsertClick() {
    CuesheetCellLinkActions.saveSelectedDocLink();
    ModalActions.hide(UIRegions.CellLink);
  },
});

/**
 * Add Link To Cell
 */
export default React.createClass({
  displayName: 'CellLinkModal',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    Reflux.connectFilter(CuesheetCellLinkStore, 'activeMode', (form) =>
      form.get('activeMode'),
    ),
    Reflux.connect(PermissionStore, 'permissions'),
    PureRenderMixin,
  ],

  render() {
    return (
      <Modal
        onHide={this._handleOnHide}
        name={UIRegions.CellLink}
        title={'Insert Link'}
        closeButton
      >
        <Grid fluid={true}>
          <Row className="tiles-wrapper">
            {this._getTileNode(
              'Insert an external link',
              'Insert a clickable link to an external URL such as google.com',
              'external',
              'external-link-square',
            )}
            {this._getTileNode(
              'Insert via file from Docs',
              'Insert a link to a file that has been uploaded to Shoflo Docs',
              'doc',
              'file-text-o',
            )}
          </Row>
          {this._getContentNode()}
        </Grid>
      </Modal>
    );
  },

  _getContentNode() {
    let activeMode = this.state.activeMode;

    if (activeMode === 'external') {
      return <ExternalLinkForm />;
    }

    return <DocLinkForm />;
  },

  _getTileNode(title, description, mode, icon) {
    let activeMode = this.state.activeMode;
    return (
      <Col md={12}>
        <Row>
          <Tile
            active={activeMode === mode}
            icon={icon}
            title={title}
            description={description}
            classes={['tile-blue']}
            handleClick={() => this._handleSetActive(mode)}
          />
        </Row>
      </Col>
    );
  },

  _handleSetActive(mode) {
    if (
      mode === 'doc' &&
      !this.state.permissions.get(UpgradeConstants.types.docs)
    )
      return UpgradeAlertModalActions.showAlert(UpgradeConstants.types.docs);

    CuesheetCellLinkActions.setActiveMode(mode);
  },

  _handleOnHide() {
    ModalActions.hide(UIRegions.CellLink);
  },
});
